const breakpoint = {
	width: $(window).width(),
	viewport_state:'',
	breakpoints:{
		'xs':0,
		'sm':576,
		'md':768,
		'lg':992,
		'xl':1200,
		'xxl':1400,
	},
	update:function(){
		this.check_state(this.viewport_state);
	},
	/* Gets the viewport status */
	check_state:function(current_state){
		switch (current_state) {
			case 'lg':
				if(this.width < this.breakpoints.md){
					this.viewport_state = 'sm';
					this.shifter();
				}
				break;
			case 'sm':
				if(this.width >= this.breakpoints.md){
					this.viewport_state = 'lg';
					this.f();
				}
				break;
			default:
				if(this.width < this.breakpoints.md){
					this.viewport_state = 'sm';
					this.shifter();
				}else{
					this.viewport_state = 'lg';
					this.shifter();
				}
				break;
		}
	},
	/* Helper function to quickly determine if a viewport is within a range */
	between:function(value, min, max){
		return value >= min && value <= max;
	},
	header:function(){
		var mobile = $('.header-cta-mobile');
		var desktop = $('.header-cta');
		if(this.viewport_state == 'lg' && desktop.html().length == 0){
			desktop.html(mobile.html());
		}
		if(this.viewport_state == 'sm' && mobile.html().length == 0){
			mobile.html(desktop.html());
		}
	},
	mega_menu:function(){
		var tabs = $('.tab-content');
		var accordions = $('.mm-panel');
		if(this.viewport_state == 'lg' && tabs.children().length == 0){
			console.log('sm->lg');
			$('.mm-panel').each(function(){  
			    $($(this).children()[0]).appendTo('.tab-content');
			});
		}
		if(this.viewport_state == 'sm' && accordions.html().length == 0){
			$('.tab-pane').each(function(){
				console.log('lg->sm');
			   $(this).appendTo($(this).attr('panel-container')); 
			});
		}
	},
	/* Controls function firing for rearranging DOM objects */
	shifter:function(){
		switch (this.viewport_state) {
			case 'sm':
				console.log('small, less than 768');
				this.header();
				this.mega_menu();
				break;
			case 'lg':
				console.log('large, greater than or equal to 768');
				this.header();
				this.mega_menu();
				break;				
			default:
				// statements_def
				break;
		}
	},
};

$(function(){
	breakpoint.update();
	$(window).on('resize', function(){
		breakpoint.update();
	});
});